export { default } from './LoggedMenu';